/**
 * components/tableElements/StatusBadge.jsx
 */

export default function StatusBadge({ status }) {
    const styles = {
        publish: "bg-green-100 text-green-800 border-green-200",
        draft: "bg-gray-100 text-gray-600 border-gray-200",
        trash: "bg-red-100 text-red-700 border-red-200",
    };

    const dots = {
        publish: "bg-green-500",
        draft: "bg-gray-400",
        trash: "bg-red-400",
    };

    if (!status) return null;
    const key = status.toLowerCase();

    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
                styles[key] ?? styles.draft
            }`}
        >
            <div
                className={`w-1.5 h-1.5 rounded-full me-1.5 ${
                    dots[key] ?? "bg-gray-400"
                }`}
            />
            {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
    );
}
